import React from "react";
import { observer } from "mobx-react";
import { Quiz } from "./Quiz";

import { useAppStore } from "../../providers/AppStoreProvider";

const Video = observer(({ currentLesson }) => {
  return (
    <div
      className="lh-base mt-3"
      dangerouslySetInnerHTML={{ __html: currentLesson?.description ?? "" }}
    />
  );
});

const Document = observer(({ currentLesson }) => {
  return (
    <div
      className="lh-base mt-3"
      dangerouslySetInnerHTML={{ __html: currentLesson?.description ?? "" }}
    />
  );
});

export const Detail = observer(() => {
  const { currentLesson } = useAppStore();
  let descJsx;

  switch (currentLesson?.lesson_type) {
    case "video":
      descJsx = <Video currentLesson={currentLesson} />;
      break;
    case "quiz":
      descJsx = <Quiz currentLesson={currentLesson} />;
      break;
    default:
      descJsx = <Document currentLesson={currentLesson} />;
      break;
  }

  return (
    <div className="description rounded-20 p-45 mb-4">
      <div>
        <div className="text-secondary">{currentLesson.chapter?.name}</div>
        <h4 className="fw-bold mb-0 mt-1">{currentLesson?.name}</h4>
      </div>

      {descJsx}
    </div>
  );
});
